import React, { useState, useEffect } from 'react';
import {
  Table, Button, Tag, Typography, Select,
} from 'antd';
import { omit } from 'lodash';
import { PlusOutlined } from '@ant-design/icons';
import { useLocation, useHistory, Link } from 'react-router-dom';
import BranchFormModal from './components/BranchFormModal';
import ActionsColumn from './components/ActionsColumn';
import AdvancedSearchForm from '../../../common/SearchForm';
import BranchDetailModal from './components/BranchDetailModal';


const { Title, Text } = Typography;
const { Option } = Select;

function MedicalHospitalBranches(props) {

  const location = useLocation();
  const history = useHistory();

  const [selectedPharmacyId, setPharmacyId] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState({});


  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onAddBranch = async (payload) => {
    const payloadObjOmitted = omit(payload, ['assets']);
    Object.keys(payloadObjOmitted).forEach((val) => {
      if (typeof payloadObjOmitted[val] === 'object') {
        payloadObjOmitted[val] = payloadObjOmitted[val].toString();
      }
    });

    const getSelectedBranchId = location.search.substring(1);
    const branchId = getSelectedBranchId.split('=')[1];

    const payloadObj = {
      id: branchId,
      payload: {
        pharmacy_branch: payloadObjOmitted
      }
    };

    await props.addAtmedVenderPharmacyBranch(payloadObj);
    await props.getAllAtmedVendorPharmacyBranches(`id=${selectedPharmacyId}`);
    hideModal();
  };

  const onUpdateVendorEquipment = async (payloadObj) => {
    await props.updateAtmedVenderPharmacyBranch(payloadObj);
    await props.getAllAtmedVendorPharmacyBranches(`id=${selectedPharmacyId}`);
  };



  useEffect(() => {
    const searchQuery = location.search.substring(1);

    if (searchQuery) {
      props.getAllAtmedVendorPharmacyBranches(searchQuery);
      setPharmacyId(Number(searchQuery.split('=')[1]));
    } else {
      history.replace('/atmed/pharmacy/partners');
    }
  }, []);
  const columns = [
    {
      title: 'Branch Name',
      key: 'name',
      dataIndex: 'name',
      render: (_, columnData) => (
        <Text underline>
          <Link onClick={() => { setDescriptionModal(true); setCurrentColumn(columnData); }}>
            <div>{columnData.name}</div>
          </Link>
        </Text>
        // <a onClick={() => setShowDetailsDrawer({id:columnData.id, service_id:columnData.service_id})}>{columnData.name}</a>
        //<a onClick={() => setShowDetailsDrawer({id:columnData.id})}>{columnData.name}</a>

      ),
    },
    {
      title: 'Address',
      key: 'address',
      render: (_, columnData) => (
        <div>{`${columnData.address}`}</div>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (_, columnData) => (
        <>
          {columnData.status ? (
            <Tag color="success">Active</Tag>
          ) : (
            <Tag color="error">Blocked</Tag>
          )}
          {columnData.verified ? (
            <Tag color="success">Verified</Tag>
          ) : (
            <Tag color="error">Unverified</Tag>
          )}
        </>
      ),
    },
    {
      title: 'Action',
      key: 'actions',
      render: (_, columnData) => (
        <>
          <ActionsColumn
            columnData={columnData}
            onUpdateVendorEquipment={onUpdateVendorEquipment}
            getSingleEquipmentUser={props.getAtmedVendorPharmacyBranchInfo}
          />
        </>
      ),
    },
  ];

  let title = '';
  if (props.pharmacy && selectedPharmacyId) {
    const index = props.pharmacy.filter((value) => value.status)
      .findIndex((val) => val.id === selectedPharmacyId);
    title = props.pharmacy.filter((value) => value.status)[index].name || '';
  }


  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join('&');
    props.getAllAtmedVendorPharmacyBranches(`${queryString}&id=${selectedPharmacyId}`);
  };



  const drawerConfig = [
    {
      displayName: ' Name',
      key: 'name',
    },
  ];

  return (
    <div>
      <BranchDetailModal
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      {/* <DetailsDrawer
        getData={() => props.getAtmedVendorHospitalBranchInfo(`${showDetailsDrawer.id}`)}
        visible={showDetailsDrawer}
        data={props.singleBranchInfo}
        setVisible={setShowDetailsDrawer}
        config={drawerConfig}
        title={`Details for Program: ${get(props.singleBranchInfo, 'id')}`}
        showMessageIfEmpty
      /> */}
      <BranchFormModal
        onSubmit={onAddBranch}
        onCancel={hideModal}
        visible={modalVisible}
        title="Add a New Branch"
        submitText="Add Branch"
      />
      <Title
        level={2}
        className="d-flex"
        style={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        {title} - Hospital / Clinic
        <Button onClick={showModal} icon={<PlusOutlined />} type="primary">
          <span style={{ fontWeight: '600' }}>
            Add Branch
          </span>
        </Button>
      </Title>
      <AdvancedSearchForm
        onSearch={onSearch}
        title="Branches"
        formItems={[
          {
            key: 'q[name_cont]',
            label: 'Branch Name',
          },
          {
            key: 'q[address_or_landmark_cont]',
            label: 'Address',
          },
          {
            key: 'q[verified_eq]',
            Component: (
              <Select placeholder="Verification Status">
                <Option>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            ),
          },
          {
            key: 'q[status_eq]',
            Component: (
              <Select placeholder="Branch Status">
                <Option>Active</Option>
                <Option value={false}>Blocked</Option>
              </Select>
            ),
          },

        ]}
      />
      <Table dataSource={props.branches} columns={columns} scroll={{ x: 800 }} />
    </div>
  );
}

export default MedicalHospitalBranches;
